<div container>
  <div class="findings d-flex flex-column flex-lg-row justify-content-lg-center gap-4 gap-lg-5">
    <div class="findings--left">
      <h2>What real people with T1D wish you knew about screening</h2>
      <p class="mb-3">
        Each year, around 64,000 Americans are diagnosed with type 1 diabetes
        (T1D). Although T1D is not preventable, findings from surveys conducted
        by Beyond Type 1 and commissioned by Sanofi show that knowing sooner
        about the risk of developing diabetes can have a big impact.
      </p>
      <p class="mb-0">
        To help understand whether knowing sooner about the risk of developing
        T1D could have a positive impact on a person’s overall well-being, a
        survey of 2,000 adults and caregivers of children with T1D was
        conducted.
      </p>
    </div>
    <div class="findings--right d-flex flex-column gap-4">
      <div class="card">
        <h3 class="mb-4 mb-lg-3">Who was surveyed?</h3>
        <ul class="mb-lg-4">
          <li>1,000 adults living with type 1 diabetes</li>
          <li>1,000 caregivers of children with type 1 diabetes</li>
        </ul>
        <div class="card__btn" global-button [buttonData]="cardButton"></div>
      </div>
      <div class="findings__list">
        <p class="mb-0">The findings:</p>
        <ol class="ps-4 mb-0">
          <li><a routerLink="/why-screen-for-t1d" fragment="fact-1">Regrets of not testing sooner</a></li>
          <li><a routerLink="/why-screen-for-t1d" fragment="fact-2">Burdens of not knowing</a></li>
          <li><a routerLink="/why-screen-for-t1d" fragment="fact-3">Impact on patients’ lives</a></li>
          <li><a routerLink="/why-screen-for-t1d" fragment="fact-4">Dangers of low awareness</a></li>
          <li><a routerLink="/why-screen-for-t1d" fragment="fact-5">Screening recommendation</a></li>
        </ol>
      </div>
    </div>
  </div>
</div>
